export default __webpack_public_path__ + "static/media/fachada-mobile.cfca1a79.jpg";